import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import EmptyState from '@/components/base/EmptyState';
import ArticleCard from '@/components/base/ArticleCard';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { getArticlesByTag, allTags } from '@/utils/articles';

export default function TagsPage() {
  const { tag = '' } = useParams();
  const list = getArticlesByTag(tag);

  useDocumentTitle({
    title: `#${tag} 相关爆料 - 91黑料网`,
    description: `91黑料网「${tag}」标签聚合页，汇总与 ${tag} 相关的娱乐黑料、明星爆料与社会热点资讯。`,
    keywords: `${tag},91黑料网,黑料资讯,爆料,热点新闻`,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-[1280px] px-4 py-6 md:px-6">
        <Breadcrumb items={[{ label: '标签聚合' }, { label: `#${tag}` }]} />

        <header className="mt-4 animate-fade-up rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <h1 className="flex items-center gap-2 text-xl font-black text-foreground-950 md:text-2xl">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-600">
              <i className="ri-price-tag-3-fill"></i>
            </span>
            #{tag}
          </h1>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这里汇总了所有标记为「{tag}」的爆料内容，共 {list.length} 条。相关话题持续更新中，点击卡片查看详情。
          </p>
          <p className="mt-3 text-xs text-foreground-500">
            其他热门标签：
            {allTags
              .filter((t) => t !== tag)
              .slice(0, 6)
              .map((t) => (
                <Link
                  key={t}
                  to={`/tags/${encodeURIComponent(t)}`}
                  className="ml-2 cursor-pointer text-primary-600 hover:text-primary-700"
                >
                  #{t}
                </Link>
              ))}
          </p>
        </header>

        <div className="mt-5">
          {list.length > 0 ? (
            <div className="flex flex-col gap-3">
              {list.map((item) => (
                <ArticleCard key={item.id} article={item} />
              ))}
            </div>
          ) : (
            <EmptyState
              title="该标签下暂无内容"
              description={`暂时没有找到与「${tag}」相关的爆料，去热门榜单看看吧。`}
              primaryLabel="查看热门排行"
              primaryTo="/hot"
            />
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}